/**
 * @file FontCustomCard.tsx
 * @description Режим «Свой шрифт» поля «Шрифт» элемента (phase19.16, партия
 * SB120 «свобода выбора», этап 0; site-builder.md SB120 «шрифт — любой из
 * каталога и своих»; uiux-sb120-fields §4): карточка «Аа Lora · с засечками ·
 * 400, 700 · Сменить». «Сменить» открывает окно каталога (`FontCatalogDialog`
 * в `FontField`).
 *
 * На 360 — одна колонка: образец и название сверху, «Сменить» справа внизу;
 * от sm — в строку. Длинное имя — до 2 строк. Состояния: список своих шрифтов
 * ещё грузится — заготовка вместо названия; шрифт удалён — «Шрифт удалён» и
 * причина под карточкой (тон error, как в сводке группы).
 */

import type { SiteFontRegistry } from "@chaiberi/shared";

import { Button } from "../../ui/button";
import { NoticeStrip } from "../../ui/NoticeStrip";
import { Skeleton } from "../../ui/skeleton";
import { FontGlyph } from "../../site-builder/section/elements/FontGlyph";
import { DELETED_FONT_TEXT, fontMetaLine, type CustomFontState } from "../../../lib/site-fields/font-field-model";

interface Props {
  fontKey: string;
  state: CustomFontState;
  registry: SiteFontRegistry;
  disabled?: boolean;
  onChange: () => void;
}

export function FontCustomCard({ fontKey, state, registry, disabled, onChange }: Props) {
  const family = registry.find(fontKey)?.family;
  const meta = state === "ok" ? fontMetaLine(fontKey, registry) : "";

  return (
    <div className="flex min-w-0 flex-col gap-2">
      <div className="flex min-w-0 flex-wrap items-center gap-x-3 gap-y-2 rounded-xl bg-surface-lowest p-3 [box-shadow:inset_0_0_0_1px_var(--border)]">
        <span className="flex min-w-0 flex-1 basis-48 items-start gap-3">
          {state === "ok" ? <FontGlyph fontKey={fontKey} weight={400} /> : <span aria-hidden className="h-6 w-8 shrink-0" />}
          <span className="flex min-w-0 flex-col">
            {state === "pending" ? (
              <Skeleton className="h-5 w-32 rounded" aria-label="Название шрифта загружается" />
            ) : (
              <span className="type-body line-clamp-2 break-words font-medium text-on-surface">{family ?? "Шрифт удалён"}</span>
            )}
            {meta ? <span className="type-caption text-on-surface-variant">{meta}</span> : null}
          </span>
        </span>
        <Button variant="outline" className="ml-auto min-h-12 shrink-0 lg:min-h-10" disabled={disabled} onClick={onChange}>
          {state === "deleted" ? "Выбрать" : "Сменить"}
        </Button>
      </div>
      {state === "deleted" ? <NoticeStrip tone="error">{DELETED_FONT_TEXT}</NoticeStrip> : null}
    </div>
  );
}
